<template>
    <div class="teach-list">
        <Top :title="name"></Top>
        <ul v-if="list.length > 0">
            <li v-for="(item,index) in list" :key="index">
                <a :href="item.link">
                    <dl>
                        <dt>
                            <div class="video-image">
                                <img :src="item.img" :alt="item.title">

                            </div>
                        </dt>
                        <dd>
                            <p>{{item.title}}</p>
                        </dd>
                    </dl>
                </a>
            </li>
        </ul>
        <div class="live-bottom" v-if="isData"><span>已展示全部内容</span></div>
        <div class="no-class-data" v-if="isNoData">
            <p>
                <img src="../../../assets/images/no_data.png" alt=""/>
            </p>
            <p>该科目暂时还没有课程哦</p>
        </div>
        <Loading :show="isUa && isLoading"></Loading>    
    </div>
</template>

<script>
import jsonp from 'jsonp'
import Top from './module/top'
import Loading from '../../loading'

export default{
    name: 'YunDangkeList',
    data(){
        return{
            cateid: this.$route.params.cateid,
            name: this.$route.params.name,
            isUa: window.navigator.userAgent.indexOf('ZgApp') < 0,
            isLoading: false,
            isData: false,
            isNoData: false,
            list: []    
        }    
    },
    mounted(){
        this.getList();  
        this.getStatistPv();  
    },
    methods:{
        getList(){
            this.isLoading = true;
            jsonp(`http://byte.gxnews.com.cn/php/zgproxy.php?action=newslist&cateid=${this.cateid}`, {} , (err, data) => {
                this.isLoading = false;
                if (err) {
                    console.error(err.message);
                } else {
                    console.log(data);
                    this.list = data.data.map(item =>{
                        return {
                            link: item.tbLive?item.tbLive.liveUrl+"?apptype=tblive&appnewsId="+item.tbLive.id : item.sharelink,
                            img: item.newPicsList[0].imgurl,
                            title: item.title
                        }
                    });
                    
                }
            })   
        },
        getStatistPv(){
            jsonp(`https://dcy.gxnews.com.cn/insert.php?myurl=http%3a%2f%2fbyte.gxnews.com.cn%2fzg%2f%23%2fyundangkeList/${encodeURI(this.name)}/${this.cateid}&sid=${this.cateid}&tag=zgapp&t=${Math.random()}`, {} , (err, data) => {
                if (err) {
                    console.error(err.message);
                } else {
                    console.log('请求成功');
                }
            })   
        }
    },
    components:{
        Top,
        Loading
    },
}
</script>

<style lang="less" scoped>
    .teach-list{
        padding: 1.3rem 0 1.6rem 0;
        h2{
            font-size: 0.45rem;
            color: #333;
            font-weight: bold;
            margin-bottom: 0.2rem;
            padding: 0 0.3rem;
            span{
                display: inline-block;
                height: 0.6rem;
                width: 0.15rem;
                background: #3793f4;
                vertical-align: middle;
                margin-right: 0.25rem;
                border-radius: 0.2rem;
            }
        }
        li{
            padding: 0 0.3rem 0.25rem 0.3rem;
            border-bottom: 1px solid #ececec;
            margin-bottom: 0.3rem;
            &:nth-last-of-type(1){
                border-bottom: none;
                margin-bottom: 0;
            }
            a{
                display: block;
            }
            dl{
                display: flex;
            }
            dt{
                width: 40%;
                .video-image{
                    position: relative;
                }
                i{
                    color: #fff;
                    position: absolute;
                }
                .play{
                    font-size: 0.7rem;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                    font-weight: bold;
                }
                .icon{
                    display: none;
                }
                img{
                    width: 100%;
                    border-radius: 0.15rem;
                }
                .play-time{
                    position: absolute;
                    right: 0.05rem;
                    bottom: 0.05rem;
                    border-radius: 0.25rem;
                    background: linear-gradient(to right, #70befd , #3a7eff);
                    color: #fff;
                    padding: 0 0.15rem;
                    font-size: 0.26rem;
                }
            }
            dd{
                flex: 1;
                padding-left: 0.3rem;
                p{
                    margin-top: 0.56rem;
                    margin-bottom: 0.16rem;
                    font-size: 0.4rem;
                    color: #000;
                    &:nth-of-type(2){
                        font-size: 0.32rem;
                        color: #4b4a4a;
                    }
                    &:nth-of-type(3){
                        font-size: 0.32rem;
                        color: #7b7a7a;
                    }
                    span{
                        margin-right: 0.2rem;
                    }
                    i{
                        display: inline-block;
                        vertical-align: middle;
                    }
                }
            }
        }
    }
    .no-class-data{
        text-align: center;
        padding-top: 4rem;
        p{
            margin-bottom: 0.25rem;
            font-size: 0.4rem;
            color: #888;
        }
        img{
            width: 30%;
        }
    }              
</style>   